import { APP_BASE_URL } from "../config";
import customHttp from "../services/customHTTP";
import { globalNavigate } from "./globalNavigation";

const KNOWN_AXIOS_CONFIG_KEYS = new Set([
	"headers",
	"params",
	"timeout",
	"onUploadProgress",
	"withCredentials",
	"responseType",
	"signal",
	"auth",
]);

const toLowerText = (value) =>
	typeof value === "string" ? value.toLowerCase() : "";

const normalizeConfig = (options) => {
	if (!options || typeof options !== "object") return {};
	const keys = Object.keys(options);
	const hasKnownKey = keys.some((key) => KNOWN_AXIOS_CONFIG_KEYS.has(key));

	if (hasKnownKey) {
		const normalized = { ...options };
		if (normalized.headers && typeof normalized.headers !== "object") {
			normalized.headers = {};
		}
		return normalized;
	}

	// Treat bare objects as header maps for backward compatibility
	return {
		headers: { ...options },
	};
};

export const handleRequest = async (
	method,
	url,
	data = null,
	options = {},
	responseType = "json"
) => {
	try {
		const verb = method.toLowerCase();
		const normalized = normalizeConfig(options);
		const config = {
			responseType: normalized.responseType || responseType,
			...normalized,
		};
		if (!config.headers) config.headers = {};

		if (verb === "get") {
			config.params = data;
			data = undefined;
		}

		let response;
		if (verb === "get") {
			response = await customHttp[verb](url, config);
		} else if (verb === "delete") {
			response = await customHttp.delete(url, { ...config, data });
		} else {
			response = await customHttp[verb](url, data, config);
		}
		if (config.responseType === "blob") {
			return response; 
		}
		return response.data; // blob, arraybuffer, or JSON depending on responseType
	} catch (error) {
		console.error(error);
		console.log("Error in: ", url, " Response: ", error.response?.data);

		if (error.response?.status === 403) {
			return error.response.data;
		}

		const errorText = toLowerText(error.response?.data?.error);
		const messageText = toLowerText(error.response?.data?.message);
		if (errorText.includes("permission") || messageText.includes("permission")) {
			return error.response.data;
		}


		if (
			error.response?.status === 401 ||
			error.response?.data?.message === "Session expired or invalid" ||
			error.response?.data?.message === "Invalid or expired JWT token"
		) {
			localStorage.clear();
			if (window.location.pathname !== "/login") {
				globalNavigate("/login", { external: true });
			}
			return {};
		}

		return error.response?.data || { error: "Unknown error" };
	}
};
